import { Direction, type Facing } from "../movement/step.ts";

/**
 * The way the local character looks, for its cone of sight (ADR-061's amendment for P1.9-T75): while it walks, the
 * way the movement keys send it, eight ways; standing, its facing, four ways. Radians on screen axes, `0` along +x
 * and `PI / 2` along +y (down the screen).
 */

/**
 * Each walking direction's heading, by `Direction` value; `None` has none.
 */
const DIRECTION_HEADINGS: readonly number[] = [Number.NaN, -Math.PI / 2, Math.PI / 2, Math.PI, 0, (-3 * Math.PI) / 4, -Math.PI / 4, (3 * Math.PI) / 4, Math.PI / 4];

/**
 * Each facing's heading, by `Facing` value.
 */
const FACING_HEADINGS: readonly number[] = [Math.PI / 2, -Math.PI / 2, Math.PI, 0];

/**
 * The heading of a character: the way it walks when it does, else the way it faces.
 *
 * @param direction The direction the movement keys last sent; `Direction.None` while it stands.
 * @param facing Its facing.
 * @returns The heading in radians.
 */
export function headingOf(direction: Direction, facing: Facing): number {
  return direction === Direction.None ? (FACING_HEADINGS[facing] as number) : (DIRECTION_HEADINGS[direction] as number);
}
